import React from 'react';
import { useSelector } from 'react-redux';
import ItemBlock from '../../itemBlock/ItemBlock';
import classes from './PromoBlock.module.scss';

const PromoBlock = ({ title, textTrans, textLogo, img, logo, link }) => {

    const { texts, lang } = useSelector(state => state.translate);

    return (
        <ItemBlock title={title ? (texts[title] || title) : null}>
            <div className={classes.wrapper}>
                <div className={classes.content}>
                    <div className={classes.rightSection}>
                        {img && <img src={img.src[lang]} alt={img.alt || ''} className={classes.image} />}
                    </div>
                    <div className={classes.leftSection}>
                        <p className={classes.TitleText}>{texts[textLogo]}</p>
                    </div>

                </div>
            </div>
        </ItemBlock>
    );
};

export default PromoBlock;